export default __webpack_public_path__ + "atomic/_patterns/02-molecules/node-footer/_node-footer.twig";